import {
    resizeFuncCheck,
    resizeFunc,
    resizecheck
} from '../common/_resizecheck';
export function contentAdjustFunc() {
    var varHeader, headerHeight, varMain;
    varHeader = $('#header');
    varMain = $('main');
    headerHeight = varHeader.outerHeight(true);
    varMain.css('padding-top', headerHeight);
}

export function resetStyleFunc() {
    var resizecheck, scrollposReset;
    resizecheck = $('#responsibleCheck').width();
    if (resizecheck != '2') {
        //pcの処理
        $('#headJs').removeAttr('style').removeClass('open');
        $('#jsMBtn').removeClass('active');
    } else {

    }
}